import React from "react";
import "./styles/Home.css";
import CodeEditor from "./CodeEditor.jsx";

import GetRandom from "../sections/GetRandom.jsx";
import GetAll from "../sections/GetAll";
import Special from "../sections/Special";
import GetByCategory from "../sections/GetByCategory";
import GetByLanguage from "../sections/GetByLanguage";
import Rate from "../sections/Rate";
import Comment from "../sections/Comment";
import Usage from "../sections/Usage";

const Home = () => {
  return (
    <div className="Home">
      <section id="intro">
        <p className="heading">
          Welcome to the only pickupLine API 💌 you'll ever need !
        </p>
        <iframe
          src="https://giphy.com/embed/ZCNjymWszyazkph0z2"
          width="480"
          height="400"
          className="giphy-embed"
          allowFullScreen
          title="hi"
          frameBorder={0}
        ></iframe>
        <p>
          <a href="https://giphy.com/gifs/Friends-season-6-friends-tv-episode-607-ZCNjymWszyazkph0z2">
            via GIPHY
          </a>
        </p>
        <p className="subheading">Hey there, how you doin ?😏</p>
        <p className="subheading" id="howudoin">
          Ready to add some 'How you doin'?' moments to your apps with our
          pickup lines? You're in the right place, pal! 🌟
        </p>
        <div className="line"></div>
        <p className="subheading" id="details">
          What is PickupLinesAPI?
        </p>
        PickupLinesAPI is a versatile and user-friendly API service that
        provides access to an extensive database of pickup lines.
        <div className="wrap">
          <div className="leftwrap">
            <span className="special">
              Whether you want to make your users smile, break the ice, or spark
              a connection, our API has you covered. It's perfect for dating
              apps, chatbots, social platforms, and more.
            </span>
          </div>
          {/* <div className="rightwrap">
            <iframe
              src="https://giphy.com/embed/Nvn7W8xEmpntua0lDy"
              width="200px"
              height="200px"
              frameBorder="0"
              class="giphy-embed"
              allowFullScreen
              title="Giphy Video"
            ></iframe>
          </div> */}
        </div>
        {/* <p className="subheading">Getting Started is a Breeze</p>
        Getting started with PickupLinesAPI is as easy as 1-2-3:
        <ul className="nums">
          <li>Sign Up: Create your account and obtain your API key.</li>
          <li>
            Explore Endpoints: Discover our comprehensive API endpoints and how
            to use them.
          </li>
          <li>
            Inject Charm: Integrate pickup lines seamlessly into your
            application and watch the magic happen.
          </li>
        </ul> */}
        {/* <p className="subheading" id="keyeatures">
          Key Features
        </p>
        <ul className="disc">
          <li>
            Extensive Categories: Choose from a wide range of categories,
            including Romantic, Funny, Cheesy, and more.
          </li>
          <li>
            Multilingual Support: Access pickup lines in various languages to
            connect with a global audience.
          </li>
          <li>
            Interactive Playground: Experiment with pickup lines in our
            interactive API playground.
          </li>
          <li>
            Rate Limiting: Stay in control with rate limiting and usage
            tracking.
          </li>
        </ul> */}
      </section>

      <section id="docs">
        <p className="heading">📖 API Documentation</p>
        Welcome to the PickupLinePro API documentation! Here, you'll find all
        the details you need to utilize our API for fetching pickup lines,
        conducting searches, rating lines, adding comments, and more.
        <p className="subheading" id="endpoints">
          🌐 Base URL
        </p>
        Before we dive in, let's establish our API's base URL:
        <CodeEditor>{`rizzapi.vercel.app/`}</CodeEditor>
        Always attach this base URL to your endpoint paths when making requests.
        <div className="line"></div>
        <div className="line"></div>
      </section>

      <GetRandom />

      <GetAll />

      <Special />

      <GetByCategory />

      <GetByLanguage />

      <section>
        <div className="dbline"></div>
        <div className="endpoint">🌟 Pickup Line Playtime 🌟</div>
        <div className="special">
          Welcome to the fun side of our API! Here, you get to rate, comment,
          and even contribute your own usage examples to our collection of
          pickup lines. 🎉
        </div>
        <div className="dbline"></div>
        <br />
      </section>

      <Rate />

      <Comment />

      <Usage />

      <section id="about">
        <div className="line"></div>
        <div className="dbline"></div>
        <div className="endpoint">Developer's Note...</div>
        <div className="heading">👋 Hi there! I'm Pratik</div>
        <div className="subheading">
          an engineering student at Pune University with a passion for crafting
          digital experiences. 🚀
        </div>
        <div>
          As the creator of this API project, I've poured my dedication and
          creativity into building a versatile and user-friendly platform that
          provides access to a wide range of pickup lines. 💌
        </div>
        <div className="dbline"></div>
        <div>
          Beyond coding, I'm an avid learner and a problem solver, always eager
          to take on new challenges. My journey in engineering has honed my
          skills in software development, and I'm excited to bring my expertise
          to a dynamic team. Feel free to explore my API project, and if you're
          interested in connecting or collaborating, don't hesitate to reach
          out. Let's create something amazing together! 🌟
        </div>
        <div className="dbline"></div>
        <div className="subheading">Let's Chat!</div>
        <div className="heading">Send Me a Message 💌</div>
        Got questions or ideas? Reach out on social media or drop me an email.
        <div className="subheading">
          <a className="socials" href="https://www.linkedin.com/in/pratikbytes">
            Connect on Linked<span className="linkedin">in</span> 📬
          </a>
        </div>
        <div className="subheading">
          <a className="socials" href="https://twitter.com/_prattiikk">
            Tweet Me ✍️
          </a>
        </div>
        <div className="subheading">
          <a className="socials" href="mailto:pvks5423@gmail.com">
            Send an Email 📧
          </a>
        </div>
        <div className="dbline"></div>
        <div className="subheading">
          "Thank you for visiting. We appreciate your time and interest. If you
          have any questions or feedback, please feel free to contact ."
        </div>
        <span className="footer">
          designed and developed by <a className="foot" href="https://www.linkedin.com/in/pratikbytes">@pratik </a>2023
        </span>
      </section>
    </div>
  );
};

export default Home;
